import {Directive, HostListener, Input, OnDestroy} from '@angular/core';
import {PopupService} from "../services/popup-service";
import {ProcessQuickMenuComponent} from "../components/process-quick-menu/process-quick-menu.component";

@Directive({
    selector: '[appProcessMenu]',
    standalone: true
})
export class ProcessMenuDirective {
    @Input('appProcessMenu') process: any; //Should have id and type

    @HostListener('contextmenu', ['$event']) processContext(event) {
        if (!this.allowDirective()) return;
        event.preventDefault();
        this.openModal(event);
    }

    constructor(private popupService: PopupService) {
    }

    allowDirective() {
        if (this.process && this.process.id && this.process.type === 'process') {
            return true;
        }
        return false;
    }

    openModal(event: any) {
        const handle = this.popupService.open(ProcessQuickMenuComponent, {
            x: event.clientX,
            y: event.clientY,
            panelClass : 'process-quick-menu-popup',
            inputs: {
                process: this.process
            },
        });
        handle.componentRef.instance.onNav.subscribe((e: any) => {
            handle.close();
        });
    }
}
